let _instance = null;

module.exports.instance = () => {
    if (_instance) return _instance;

    _instance = {
        lastAnswer: '',
        lastAnswerName: ''
    };

    return _instance;
};
